import $ from 'jquery';
import 'home24-intl-tel-input/build/js/intlTelInput';
import BaseView from '../core/baseView';
import * as eventEmitter from '../core/eventEmmiter';

import utilsScript from 'file-loader?name=[hash:6].[ext]!home24-intl-tel-input/build/js/utils.min';

export default BaseView.extend({
    selectors: {
        wrapper: '.intl-tel-input',
        clone: '.js-phone-formatter-clone'
    },

    events: {
        change: 'onChange',
        blur: 'onChange'
    },

    preferredCountries: ['de', 'fr', 'nl', 'at', 'ch', 'be', 'it'],

    initialize: function () {
        var self = this;

        if (self.$el.length === 1) {
            self.name = self.$el.prop('name');
            self.$clone = self.createHiddenInput();
            self.formatCountryData();

            self.intlTelInputDeferred = self.$el.intlTelInput({
                defaultCountry: $('html')
                    .prop('lang')
                    .toLowerCase()
                    .split('-')[1],
                preferredCountries: self.preferredCountries,
                autoPlaceholder: true,
                utilsScript
            });

            self.$el.prop('name', '')
                .closest(self.selectors.wrapper).after(self.$clone);

            self.intlTelInputDeferred.done(function () {
                self.updatePhoneNumber();
            });
            self.bindEvents();
        } else {
            self.destroy();
        }
    },

    destroy: function () {
        if (this.$el.length === 1) {
            this.$el.val(this.$clone.val())
                .prop('name', this.name)
                .intlTelInput('destroy');
            this.$clone.remove();
        }

        this.undelegateEvents();
        this.$el.removeData().unbind();
    },

    bindEvents: function () {
        eventEmitter.on('change:telephoneField', this.updatePhoneNumber, this);
    },

    onChange: function () {
        this.$clone.val(this.$el.intlTelInput('getNumber') || this.$el.val());
        this.$clone.trigger('blur');
    },

    createHiddenInput: function () {
        var $clone = this.$el.closest(this.selectors.wrapper).next(this.selectors.clone);

        if (!$clone.length) {
            $clone = this.$el.clone();
            $clone.css({
                position: 'absolute',
                left: '-9999px'
            });
        }

        return $clone;
    },

    updatePhoneNumber: function () {
        var number = this.$el.intlTelInput('getNumber');

        if (number) {
            this.$el.intlTelInput('setNumber', number);
        }
    },

    formatCountryData: function () {
        var countryData = $.fn.intlTelInput.getCountryData();

        $.each(countryData, function (i, country) {
            country.name = country.name.replace(/.+\((.+)\)/, '$1');
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/phoneNumberFormatterView.js
 **/